export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Website-Gray-d3ac29ad59d3018fcb440981ec064d8b.svg";